import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  title: yup.string().required("Campaign name is required"),
  description: yup.string().optional(),
  customer_ids: yup.array().of(yup.string()),
});

export const useValidation = ({ ...rest }) => {
  return useForm({
    resolver: yupResolver(schema),
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      ...rest,
    },
  });
};
